import Button from '../ui/Button.jsx';
import { Card, CardBody, CardHeader } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';
import { useEffect } from 'react';

const Text = ({ ...props }) => {
    const { icon, heading, action, feedback, fn } = props;

    useEffect(() => {
        const [actionName, actionValue] = action.split(':');
        if('onload.send' === actionName) {
            fn.handleSend(actionValue)
        }
    }, []);

    return (
        <div className="component-message">
            <HeadingOne icon={icon} heading={heading} />

            <div className="row justify-center">
                <div className="col xl:w-10/12">
                    <Card>
                        <CardHeader heading={feedback?.heading ?? ''} />
                        <CardBody>
                            <div className="row items-center justify-center">
                                <div className="col lg:w-7/12">
                                    <div className="md:pl-8 lg:pl-12 text-center text-balance">
                                        <div dangerouslySetInnerHTML={{ __html: feedback?.message ?? '' }}></div>

                                        {feedback && (
                                            <div className="mt-12">
                                                <Button onClick={() => fn.handleAction(feedback?.action)}>
                                                    Jdu do toho
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default Text;
